<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="
                  isDeletePage() != true
                    ? 'Old User Datas'
                    : 'Deleted Old User Datas'
                "
              ></h3>
              <template v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/old-user-datas/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/old-user-datas/upload"
                >
                  <v-icon dark> mdi-upload </v-icon>
                </v-btn>
              </template>
            </v-card-title>
            <v-card-text>
              <v-row align="center">
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    hide-details="auto"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.status"
                    :items="statuses"
                    clearable
                    @click:clear="(filter.status = null), (page = 1)"
                    label="Status"
                    hide-details="auto"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
                <v-spacer></v-spacer>
                <v-col>
                  <v-btn color="primary" @click="verifyOldUserData">
                    Verify Old User Data
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="min-height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                min-height="530"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left sr_no">Sr No</th>
                      <th class="text-left">Status</th>
                      <th class="text-left" style="min-width: 130px">Date</th>
                      <th class="text-left" style="min-width: none">Name</th>
                      <th class="text-left" style="min-width: none">
                        Phone No.
                      </th>
                      <th class="text-left" style="min-width: none">
                        Invoice No.
                      </th>
                      <th class="text-left" style="min-width: none">Product</th>
                      <th class="text-left" style="min-width: none">HSN/SAC</th>
                      <th class="text-left" style="min-width: none">
                        Quantity
                      </th>
                      <th class="text-left" style="min-width: none">Unit</th>
                      <th class="text-left" style="min-width: 100px">
                        Price Per Unit
                      </th>
                      <th class="text-left" style="min-width: none">
                        Discount
                      </th>
                      <th class="text-left" style="min-width: none">GST</th>
                      <th class="text-left" style="min-width: none">Amount</th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="old_user_datas.length != 0">
                    <tr
                      v-for="(old_user_data, i) in old_user_datas"
                      :key="`old_user_data_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': old_user_datas.length - 1 == i,
                      }"
                    >
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="old_user_data.status == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="primary"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Pending
                            </v-chip>
                          </template>
                          <span>Old User Data is Pending</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="old_user_data.status == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Uploaded
                            </v-chip>
                          </template>
                          <span>Old User Data is Uploaded</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="old_user_data.status == 2">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="yellow"
                              text-color="black"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              KYC Not Verified
                            </v-chip>
                          </template>
                          <span>Old User Data is KYC Not Verify</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="old_user_data.status == 3">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Not Registered
                            </v-chip>
                          </template>
                          <span>Old User Data is not Registered</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="old_user_data.status == 4">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="orange"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-account-cancel</v-icon>
                              </v-avatar>
                              Rejected
                            </v-chip>
                          </template>
                          <span>Old User Data is Rejected (Not a Driver)</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="old_user_data.status == 5">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="green"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-check-circle</v-icon>
                              </v-avatar>
                              Verified
                            </v-chip>
                          </template>
                          <span
                            >Old User Data is Verified and Ready for
                            Upload</span
                          >
                        </v-tooltip>
                      </td>
                      <td>
                        {{ formattedDate(old_user_data.date) || "" }}
                      </td>
                      <td>
                        {{ old_user_data.user_name || "" }}
                      </td>
                      <td>
                        {{ old_user_data.phone || "" }}
                      </td>
                      <td>
                        {{ old_user_data.invoice_no || "" }}
                      </td>
                      <td>
                        {{ old_user_data.product || "" }}
                      </td>
                      <td>
                        {{ old_user_data.hsn_sac || "" }}
                      </td>
                      <td>
                        {{ old_user_data.quantity || "" }}
                      </td>
                      <td>
                        {{ old_user_data.unit || "" }}
                      </td>
                      <td>
                        {{ old_user_data.price_per_unit || "" }}
                      </td>
                      <td>
                        {{ old_user_data.discount || "" }}
                      </td>
                      <td>
                        {{ old_user_data.gst || "" }}
                      </td>
                      <td>
                        {{ old_user_data.amount || "" }}
                      </td>
                      <td class="text-right">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="handleStatus(old_user_data)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this Old User Data</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/old-user-datas/${encryptIt(
                                  old_user_data.id
                                )}`"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this Old User Data</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="restoreData(old_user_data.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this old user data</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="7" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination
                rounded
                v-model="page"
                :length="paginationLength"
                :total-visible="10"
              >
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_old_user_data" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Old User Data deleted successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_deleted_old_user_data = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_old_user_data" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Old User Data restored successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_restored_old_user_data = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>

      <!-- Confirmation Dialog Component -->
      <ConfirmationDialog
        :show.sync="dialog"
        :title="dialogTitle"
        :message="dialogMessage"
        :icon="dialogIcon"
        :color="dialogColor"
        @confirm="confirmApproval"
      />

      <!-- Verified Dialog Component -->
      <v-dialog v-model="showVerifyDialog" max-width="900px" persistent>
        <v-card elevation="12" class="rounded-xl">
          <v-card-title class="text-h6 font-weight-bold blue--text">
            <v-icon color="primary" class="mr-2">mdi-check-decagram</v-icon>
            Verification Result Summary
          </v-card-title>

          <v-divider class="my-1"></v-divider>

          <v-card-text class="pt-4">
            <v-tabs
              v-model="verifyTab"
              color="primary"
              centered
              slider-color="primary"
              class="rounded-lg mb-4"
            >
              <v-tab> <v-icon left>mdi-cloud-upload</v-icon> Pending </v-tab>
              <v-tab> <v-icon left>mdi-check-circle</v-icon> Verified </v-tab>
              <v-tab> <v-icon left>mdi-cloud-upload</v-icon> Uploaded </v-tab>
              <v-tab>
                <v-icon left>mdi-account-alert</v-icon> KYC Not Verified
              </v-tab>
              <v-tab>
                <v-icon left>mdi-account-remove</v-icon> Not Registered
              </v-tab>
              <v-tab> <v-icon left>mdi-account-cancel</v-icon> Rejected </v-tab>
            </v-tabs>

            <v-tabs-items v-model="verifyTab">
              <v-tab-item>
                <v-data-table
                  :headers="headers"
                  :items="formattedResults.pending"
                  dense
                  class="elevation-1 rounded-lg"
                ></v-data-table>
              </v-tab-item>
              <v-tab-item>
                <v-data-table
                  :headers="headers"
                  :items="formattedResults.verified"
                  dense
                  class="elevation-1 rounded-lg"
                ></v-data-table>

                <!-- Upload Data button for verified entries -->
                <div
                  class="text-center mt-4"
                  v-if="formattedResults.verified.length > 0"
                >
                  <v-btn
                    color="success"
                    large
                    :loading="isUploading"
                    :disabled="isUploading"
                    @click="uploadVerifiedData"
                  >
                    <v-icon left>mdi-cloud-upload</v-icon>
                    Upload Data
                  </v-btn>
                </div>
              </v-tab-item>
              <v-tab-item>
                <v-data-table
                  :headers="headers"
                  :items="formattedResults.uploaded"
                  dense
                  class="elevation-1 rounded-lg"
                ></v-data-table>
              </v-tab-item>
              <v-tab-item>
                <v-data-table
                  :headers="headers"
                  :items="formattedResults.kycNotVerified"
                  dense
                  class="elevation-1 rounded-lg"
                ></v-data-table>
              </v-tab-item>
              <v-tab-item>
                <v-data-table
                  :headers="headers"
                  :items="formattedResults.notRegistered"
                  dense
                  class="elevation-1 rounded-lg"
                ></v-data-table>
              </v-tab-item>
              <v-tab-item>
                <v-data-table
                  :headers="headers"
                  :items="formattedResults.rejected"
                  dense
                  class="elevation-1 rounded-lg"
                ></v-data-table>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>

          <v-card-actions class="justify-end">
            <v-btn
              color="primary"
              :loading="isVerifying"
              :disabled="isVerifying"
              @click="performVerification"
            >
              <v-icon left>mdi-check-decagram</v-icon> Verify
            </v-btn>
            <v-btn color="red lighten-1" text @click="showVerifyDialog = false">
              <v-icon left>mdi-close</v-icon> Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import ConfirmationDialog from "@/components/ConfirmationDialog.vue";
export default {
  components: { ConfirmationDialog },
  name: "OldUserDatasPage",
  data() {
    return {
      filter: {
        is_active: "",
        search_keyword: "",
        show_deleted: false,
        status: false,
      },
      old_user_datas: [],
      statuses: [
        { id: "", text: "STATUS", value: "" },
        { id: 0, text: "PENDING", value: 0 },
        { id: 1, text: "UPLOADED", value: 1 },
        { id: 2, text: "KYC NOT VERIFIED", value: 2 },
        { id: 3, text: "NOT REGISTERED", value: 3 },
        { id: 4, text: "REJECTED", value: 4 },
        { id: 5, text: "VERIFIED", value: 5 },
      ],
      ExportOldUserDataTypes: [],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
      },
      isLoading: false,
      isExcelloading: false,
      delete_old_user_data: false,
      is_deleted_old_user_data: false,
      is_restored_old_user_data: false,

      selectedUserDataId: null,
      dialog: false,
      dialogTitle: "",
      dialogMessage: "",
      dialogIcon: "",
      dialogColor: "",

      showVerifyDialog: false,
      verifyTab: 0,
      formattedResults: {
        uploaded: [],
        kycNotVerified: [],
        notRegistered: [],
        rejected: [],
        verified: [],
      },
      isUploading: false,
      isVerifying: false,
      headers: [
        { text: "Phone Number", value: "phone" },
        { text: "Sales Count", value: "count" },
      ],
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;

      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.search_keyword = this.filter.search_keyword || "";
      this.filter.status = this.filter.status || "";

      let query = new URLSearchParams({
        page: this.page,
        rowsPerPage: this.rowsPerPage,
        ...this.filter,
      });

      await axios
        .get(`old_user_datas?${query}`)
        .then((response) => {
          this.old_user_datas = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },
    //Generate Excel
    async generateExcel() {
      let query = "search_keyword=" + this.filter.search_keyword;
      let response = await axios.get(`old_user_data_exports?${query}`);
      console.log(response.data.data);
      if (response) {
        window.open(`${response.data.data}`, "_blank");
      }
    },
    async restoreData(id) {
      this.restore_old_user_data = true;
      await axios
        .post(`/old_user_datas/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_old_user_data = false;
          this.is_restored_old_user_data = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
    async deleteData(id) {
      await axios
        .post(`/old_user_datas/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
    handleStatus(data) {
      this.dialogTitle = "Delete Data";
      this.dialogMessage = "Are you sure you want to delete this user data?";

      this.dialogIcon = "mdi-alert-circle-outline";

      this.dialogColor = "red";

      this.selectedUserDataId = data.id;
      this.dialog = true; // Open dialog
    },
    async confirmApproval() {
      await axios
        .post(
          `/old_user_datas/delete/${this.encryptIt(this.selectedUserDataId)}`
        )
        .then(() => {
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },

    async verifyOldUserData() {
      // Load preview data and show dialog
      await this.loadPreviewData();
      this.showVerifyDialog = true;
    },
    transformCountArray(countArray) {
      // Converts [{"9369069200": 2}] to [{ phone: "9369069200", count: 2 }]
      return countArray.map((obj) => {
        const phone = Object.keys(obj)[0];
        return { phone: phone, count: obj[phone] };
      });
    },

    async uploadVerifiedData() {
      this.isUploading = true;
      try {
        const response = await axios.post("/old_user_datas/upload_verified");

        // Show success message or handle response
        this.$notify({
          group: "foo",
          title: "Upload Success",
          text: response.data.message || "Verified data uploaded successfully",
          type: "success",
        });

        // Refresh the data and close dialog
        await this.loadPreviewData();
        this.getData();
        this.showVerifyDialog = false;
      } catch (error) {
        console.error("Upload failed:", error);

        // Show error message
        this.$notify({
          group: "foo",
          title: "Upload Failed",
          text:
            error.response?.data?.message || "Failed to upload verified data",
          type: "error",
        });
      } finally {
        this.isUploading = false;
      }
    },

    async performVerification() {
      this.isVerifying = true;
      try {
        const response = await axios.get("/old_user_datas/verify");

        // Show success message
        this.$notify({
          group: "foo",
          title: "Verification Success",
          text: response.data.message || "Data verified successfully",
          type: "success",
        });

        // Refresh preview data after verification
        await this.loadPreviewData();

        // Refresh the main data table
        this.getData();
      } catch (error) {
        console.error("Verification failed:", error);

        // Show error message
        this.$notify({
          group: "foo",
          title: "Verification Failed",
          text: error.response?.data?.message || "Failed to verify data",
          type: "error",
        });
      } finally {
        this.isVerifying = false;
      }
    },

    async loadPreviewData() {
      try {
        const response = await axios.get("/old_user_datas/preview_data");
        const result = response.data.data;

        this.formattedResults.uploaded = this.transformCountArray(
          result.uploaded_count || []
        );
        this.formattedResults.pending = this.transformCountArray(
          result.pending_count || []
        );
        this.formattedResults.kycNotVerified = this.transformCountArray(
          result.kyc_not_verified_count || []
        );
        this.formattedResults.notRegistered = this.transformCountArray(
          result.not_registered_count || []
        );
        this.formattedResults.rejected = this.transformCountArray(
          result.rejected_count || []
        );
        this.formattedResults.verified = this.transformCountArray(
          result.verified_count || []
        );
      } catch (error) {
        console.error("Failed to load preview data:", error);
      }
    },
  },
};
</script>
<style scoped>
.v-data-table-header {
  font-weight: 600;
}
</style>
